module.exports = __webpack_public_path__ + "img/wap-question-banner.f01505fe.png";